(() => {
  if (window.__alDeferredVideoPosters) {
    window.__alDeferredVideoPosters.scan(document);
    return;
  }

  const reveal = (video) => {
    const poster = video.dataset.alDeferredPoster;
    if (poster) {
      video.poster = poster;
      delete video.dataset.alDeferredPoster;
    }

    const fallback = video.querySelector('img[data-al-deferred-src]');
    if (fallback) {
      fallback.src = fallback.dataset.alDeferredSrc;
      delete fallback.dataset.alDeferredSrc;
    }
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' })
    : null;

  const bind = (video) => {
    if (video.dataset.alDeferredBound === 'true') return;
    video.dataset.alDeferredBound = 'true';

    if (!observer) {
      reveal(video);
      return;
    }

    const revealNow = () => {
      reveal(video);
      observer.unobserve(video);
    };

    video.addEventListener('pointerdown', revealNow, { once: true, passive: true });
    video.addEventListener('focus', revealNow, { once: true });
    observer.observe(video);
  };

  const scan = (root = document) => {
    if (root.matches?.('video[data-al-deferred-poster]')) bind(root);
    root.querySelectorAll?.('video[data-al-deferred-poster]').forEach(bind);
  };

  window.__alDeferredVideoPosters = { scan };

  const initialize = () => {
    scan(document);

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();